// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_14-1";
export var movingGradient = "_14-4";
export var movingGradientBlock = "_14-2";
export var skeleton = "_14-0";
export var skeletonText = "_14-3";